import React, { useContext, useEffect,lazy } from "react";
// import MapScreen from './MapScreen';
import pin from "../img/pin.png";
import SimpleContext from "../context/SimpleContext";
import Preloader from "./Preloader2";
const MapScreen = lazy(() => {
  return new Promise((resolve) => setTimeout(resolve, 1000)).then(() =>
    import("./MapScreen")
  );
});

const UserLocation = () => {
  const context = useContext(SimpleContext);
  const sabt = () => {
    context.postloc();
  };

  useEffect(() => {
    let url = window.location.href.split("/")[4];
    if (url === "userLocation") {
      let mainUrl = window.location.href.split("/")[5].split("&");
      context.setuserIdMap(parseInt(mainUrl[0].split("=")[1]));
      context.setuserCodeMap(parseInt(mainUrl[1].split("=")[1]));
      context.setuserPhoneMap(parseInt(mainUrl[2].split("=")[1]));
      context.setlatCenter(parseFloat(mainUrl[3].split("=")[1]));
      context.setlangCenter(parseFloat(mainUrl[4].split("=")[1]));
      context.setUserLat(parseFloat(mainUrl[3].split("=")[1]))
      context.setUserLang(parseFloat(mainUrl[4].split("=")[1]))

    }
  }, []);


  
  return (
    <div className="location">
      <MapScreen />
      <img className="map-pin" src={pin} />
      {/* <img className="map-pin2" src={pin} /> */}
      {context.mapLoader === true ? (
        <button className="map-pin-button">
          <Preloader />
        </button>
      ) : (
        <button onClick={() => sabt()} className="map-pin-button">
          ثبت نقشه
        </button>
      )}
    </div>
  );
};

export default UserLocation;
